export default __webpack_public_path__ + "static/media/answers_long.a5a568bb.svg";